<section class="pt-6 pb-12" *transloco="let t; prefix: 'property-details.costs-section'">
  <h2 class="text-[1.75rem] font-semibold text-black pb-6">
    {{ t("header") }}
  </h2>

  <div class="relative">
    <div class="cost-wrapper">
      <div class="cost-row heading">
        <div class="cost-row-item extra-span">
          {{ t("table-header.title") }}
          <div class="cost-mobile-item">
            {{ propertyValue | currency: 'EUR' : 'symbol' : '1.0-0' }}
          </div>
        </div>
        <div class="cost-row-item">{{ propertyValue | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
      </div>

      <!-- Notary Fees -->
      <div class="cost-row">
        <div class="cost-row-item extra-span">
          <div class="button-wrapper" [ngClass]="{ active: accordionItems[0].active }">
            <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(0)"
              [ngClass]="{ active: accordionItems[0].active }">
              <i class="icon-chevron-up"></i>
              {{ t("table-body.notary-fee.title") }}
              <div class="cost-mobile-item">
                {{ fees.notaryExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
              </div>
            </button>
          </div>
          <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[0].active }">
            {{ t('table-body.notary-fee.body') }}
          </div>
        </div>
        <div class="cost-row-item">
          <div>{{ fees.notaryExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
        </div>
      </div>

      <!-- Real Estate Transfer Tax (RETT) -->
      <div class="cost-row">
        <div class="cost-row-item extra-span">
          <div class="button-wrapper" [ngClass]="{ active: accordionItems[1].active }">
            <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(1)"
              [ngClass]="{ active: accordionItems[1].active }">
              <i class="icon-chevron-up"></i>
              {{ t("table-body.real-estate-transfer-tax.title") }}
              <div class="cost-mobile-item">
                {{ fees.propertyTransferTax?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
              </div>
            </button>
          </div>
          <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[1].active }">
            {{ t('table-body.real-estate-transfer-tax.body') }}
          </div>
        </div>
        <div class="cost-row-item">
          <div>{{ fees.propertyTransferTax?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
        </div>
      </div>

      <!-- Contract Registration Fees -->
      <div class="cost-row">
        <div class="cost-row-item extra-span">
          <div class="button-wrapper" [ngClass]="{ active: accordionItems[2].active }">
            <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(2)"
              [ngClass]="{ active: accordionItems[2].active }">
              <i class="icon-chevron-up"></i>
              {{ t("table-body.contract-registration-fee.title") }}
              <div class="cost-mobile-item">
                {{ fees.contractRegistration?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
              </div>
            </button>
          </div>
          <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[2].active }">
            {{ t('table-body.contract-registration-fee.body') }}
          </div>
        </div>
        <div class="cost-row-item">
          <div>{{ fees.contractRegistration?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
        </div>
      </div>

      <!-- Real Estate Agent Fee -->
      @if (!isAuctioned) {
        <div class="cost-row">
          <div class="cost-row-item extra-span">
            <div class="button-wrapper" [ngClass]="{ active: accordionItems[3].active }">
              <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(3)"
                [ngClass]="{ active: accordionItems[3].active }">
                <i class="icon-chevron-up"></i>
                {{ t("table-body.real-estate-agency-fee.title") }}
                <div class="cost-mobile-item">
                  {{ fees.realEstateAgencyFee?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
                </div>
              </button>
            </div>
            <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[3].active }">
              {{ t('table-body.real-estate-agency-fee.body') }}
            </div>
          </div>
          <div class="cost-row-item">
            <div>{{ fees.realEstateAgencyFee?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
          </div>
        </div>
      }

      <!-- Legal Due Diligence -->
      @if (!isAuctioned) {
        <div class="cost-row">
          <div class="cost-row-item extra-span">
            <div class="button-wrapper" [ngClass]="{ active: accordionItems[4].active }">
              <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(4)"
                [ngClass]="{ active: accordionItems[4].active }">
                <i class="icon-chevron-up"></i>
                {{ t("table-body.legal-due-diligence.title") }}
                <div class="cost-mobile-item">
                  {{ fees.legalDueDiligence?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
                </div>
              </button>
            </div>
            <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[4].active }">
              {{ t('table-body.legal-due-diligence.body') }}
            </div>
          </div>
          <div class="cost-row-item">
            <div>{{ fees.legalDueDiligence?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
          </div>
        </div>
      }

      <!-- Other notary costs -->
      <div *ngIf="isAuctioned" class="cost-row">
        <div class="cost-row-item extra-span">
          <div class="button-wrapper" [ngClass]="{ active: accordionItems[5].active }">
            <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(5)"
              [ngClass]="{ active: accordionItems[5].active }">
              <i class="icon-chevron-up"></i>
              {{ t("table-body.other-notary-expenses.title") }}
              <div class="cost-mobile-item">
                {{ fees.otherNotaryExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
              </div>
            </button>
          </div>
          <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[5].active }">
            {{ t('table-body.other-notary-expenses.body') }}
          </div>
        </div>
        <div class="cost-row-item">
          <div>{{ fees.otherNotaryExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
        </div>
      </div>

      <!-- Other auction costs -->
      <div *ngIf="isAuctioned" class="cost-row">
        <div class="cost-row-item extra-span">
          <div class="button-wrapper" [ngClass]="{ active: accordionItems[6].active }">
            <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(6)"
              [ngClass]="{ active: accordionItems[6].active }">
              <i class="icon-chevron-up"></i>
              {{ t("table-body.other-auction-expenses.title") }}
              <div class="cost-mobile-item">
                {{ fees.otherAuctionExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
              </div>
            </button>
          </div>
          <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[6].active }">
            {{ t('table-body.other-auction-expenses.body') }}
          </div>
        </div>
        <div class="cost-row-item">
          <div>{{ fees.otherAuctionExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
        </div>
      </div>

      <!-- Property Evaluation And Auction Support Costs -->
      @if (isAuctioned) {
        <div class="cost-row">
          <div class="cost-row-item extra-span">
            <div class="button-wrapper" [ngClass]="{ active: accordionItems[7].active }">
              <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(7)"
                      [ngClass]="{ active: accordionItems[7].active }">
                <i class="icon-chevron-up"></i>
                {{t("table-body.property-evaluation-and-auction-support-expenses.title")}}
                <div class="cost-mobile-item">
                  {{ fees.propertyEvaluationAndAuctionSupportExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
                </div>
              </button>
            </div>
            <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[7].active }">
              {{t("table-body.property-evaluation-and-auction-support-expenses.body")}}
            </div>
          </div>
          <div class="cost-row-item">
            <div>{{ fees.propertyEvaluationAndAuctionSupportExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
          </div>
        </div>
      }

      <!-- Removal from auction & registration -->
      <div *ngIf="isAuctioned" class="cost-row">
        <div class="cost-row-item extra-span">
          <div class="button-wrapper" [ngClass]="{ active: accordionItems[8].active }">
            <button class="w-full flex flex-row items-center gap-2 px-2" type="button" (click)="toggleAccordion(8)"
              [ngClass]="{ active: accordionItems[8].active }">
              <i class="icon-chevron-up"></i>
              {{ t("table-body.auction-removal-and-registration-expenses.title") }}
              <div class="cost-mobile-item">
                {{ fees.auctionRemovalAndRegistrationExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}
              </div>
            </button>
          </div>
          <div class="overflow-hidden rfs:pl-8" [ngClass]="{ 'h-0': !accordionItems[8].active }">
            {{ t('table-body.auction-removal-and-registration-expenses.body') }}
          </div>
        </div>
        <div class="cost-row-item">
          <div>{{ fees.auctionRemovalAndRegistrationExpenses?.fee | currency: 'EUR' : 'symbol' : '1.0-0' }}</div>
        </div>
      </div>

      <!-- Total -->
      <div class="cost-row">
        <div class="cost-row-item extra-span">
          <div class="button-wrapper">
            <div class="w-full flex flex-row items-center gap-2 px-2 lg:px-8">
              <div class="cost-mobile-item font-semibold">
                {{ t('sum') }}
              </div>
            </div>
          </div>
        </div>
        <div class="cost-row-item !block !pr-4 font-semibold">
          {{ feesSum | currency: 'EUR' : 'symbol' : '1.0-0' }}
        </div>
      </div>

    </div>
    <app-locked-content-overlay [isVissible]="!isLoggedIn"></app-locked-content-overlay>
  </div>
</section>
